import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/megaport': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256 0 393 111 504 248 504 385 504 496 393 496 256 496 119 385 8 248 8zM333.5 275.7L393.1 335.3V422.4L367.1 441.6 341 422.4V356.9L307.6 323.5 274.1 356.9V422.4L248 441.6 221.9 422.4V356.9L188.4 323.5 155 356.9V422.4L128.9 441.6 102.9 422.4V335.3L162.3 275.9V188L221.8 128.5V52.9L247.9 33.6 274 52.9V128.5L333.5 188M247.9 176.2L281.3 209.6V276L248 309.3 214.5 275.8V209.6L247.9 176.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/megaport.js
// module id = fX5x
// module chunks = 144